"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable consistent-return */
var safeParse_1 = __importDefault(require("./safeParse"));
var isServerSideRendering_1 = __importDefault(require("./isServerSideRendering"));
/**
 * Retrieves and parses a given cookie value by name. Encoded URI component
 * strings will be decoded and JSON strings will be parsed into actual JSON,
 * and numeric strings will be parsed as Numbers.
 */
function getCookie(key) {
    if (isServerSideRendering_1.default())
        return;
    var cookie = document.cookie
        .split('; ')
        .map(function (c) { return c.split('='); })
        .find(function (c) { return c[0] === key; });
    if (!cookie || cookie[1] === undefined)
        return undefined;
    var val = decodeURIComponent(cookie[1]);
    if (!Number.isNaN(Number(val))) {
        return Number(val);
    }
    return safeParse_1.default(val) || val;
}
exports.default = getCookie;
//# sourceMappingURL=getCookie.js.map